/* eslint-disable import/first */
/* eslint-disable camelcase */
__webpack_public_path__ = window.s3R53;
/* eslint-enable camelcase */
import './polyfill.js';
import './overrides.js';
import qs from 'store/entities/QueryString'; // initializes query params
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { ConnectedRouter } from 'react-router-redux';
import createHistory from 'history/createHashHistory';

// Components
import LanguageProvider from 'components/common/providers/i18n/LanguageProvider';
import ThemeProvider from 'components/common/providers/theme/ThemeProvider';
// import PageLoader from 'components/common/loader/PageLoader';

import Consumer8 from 'components/consumer8/App';
import StatusTracker from 'components/statusTracker/App';
import SelfCheckIn from 'components/selfCheckIn/App';

// Utils
import {
  getMetaTagContentByName,
  isMicrosite,
  isStaticHosted
} from 'utils/DOM';
import 'utils/adaConfigurations/focus-visible';
import { addIndexDirectionListener } from 'utils/adaConfigurations/ModalFocusPrision';

// Constants
import { APP_NAMES } from 'constants/appName';

const { STATUS_TRACKER, SELF_CHECK_IN, CONSUMER_8 } = APP_NAMES;

// Store
import configureStore from './store/';
import initialState from 'store/initialState';
import { initData } from 'store/reducers/ajaxCall/actions';
import { setQueryParams } from 'store/reducers/queryParams/actions';
import { setAppName } from 'store/reducers/userInteractions/actions';
import { isDeeplink } from 'store/reducers/deeplink/actions';
import { setIsSciNavigating } from 'store/reducers/selfCheckIn/actions';
import { setOptimizelyABTest } from 'store/reducers/optimizelyABTest/actions';
import { setScripts } from 'store/reducers/scripts/actions';

// verify this style file :'(
// import './index.scss';
const history = createHistory({
  basename: '', // root
  hashType: 'slash' // the default
});

// @TODO: refactor qs.getAppName() is for debugging
const appNameTag = getMetaTagContentByName('xtime:appName');
const appName = appNameTag || qs.getAppName();
const isConsumer8 = CONSUMER_8 === appName;
const store = configureStore(initialState, history);
const data = getMetaTagContentByName('xtime:dealerData');

const scripts = getMetaTagContentByName('xtime:scripts');
store.dispatch(setScripts(JSON.parse(scripts)));

// VMODE=TRUE
const modalView = qs.get('redirect') === 'true' && qs.get('vmode') === 'true';
modalView && window.top.postMessage('closeC8Modal', '*');

// @TODO: refactor for SS and C8, initial development is for SCI
if (isMicrosite() || isStaticHosted()) {
  const params = getMetaTagContentByName('xtime:queryParams');
  store.dispatch(setQueryParams(JSON.parse(params)));
} else {
  store.dispatch(setQueryParams());
}

store.dispatch(setAppName(appName));
if (window.optimizelyABTest) {
  store.dispatch(setOptimizelyABTest(window.optimizelyABTest));
}

if (isConsumer8) {
  store.dispatch(isDeeplink());
}
store.dispatch(initData(JSON.parse(data), isConsumer8));
if (appName === SELF_CHECK_IN) {
  store.dispatch(setIsSciNavigating(true));
}
if (process.NODE_ENV !== 'production') {
  // debugging purposes
  window.store = store;
}
addIndexDirectionListener();

// @TODO: revert to this implementation when blob css lodings is fixed
// function getApp() {
//   const path = isConsumer8 ? 'consumer8' : 'statusTracker';
//   /* eslint-disable new-cap */
//   const App = PageLoader({
//     loader: () => import(`./components/${path}/App.js`)
//   });
//   /* eslint-enable new-cap */
//   return <App />;
// }

function getApp() {
  switch (appName) {
    case SELF_CHECK_IN:
      return <SelfCheckIn />;
    case STATUS_TRACKER:
      return <StatusTracker />;
    case CONSUMER_8:
    default:
      return <Consumer8 />;
  }
}

function render() {
  ReactDOM.render(
    <Provider store={store}>
      <ThemeProvider>
        <LanguageProvider>
          <ConnectedRouter history={history}>{getApp()}</ConnectedRouter>
        </LanguageProvider>
      </ThemeProvider>
    </Provider>,
    document.getElementById('root')
  );
}

// load i18n polyfill first
if (!window.Intl) {
  import('intl')
    .then(() =>
      Promise.all([
        import(// TODO: import correct locale on demand
        'intl/locale-data/jsonp/en.js')
      ])
    )
    .then(() => render({}));
} else {
  render({});
}



// WEBPACK FOOTER //
// ./src/index.js